import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiSingWallet from 'libs/apiSingWallet';
import { _DataQuery } from 'types/data';
import { Profile } from 'types/profile';
import type { RootState } from '../../app/store'

export const checkAuthenticated = createAsyncThunk('user/check', async (_arg: string, thunkApi) => {
    let token: string | null = null
    let base64ToString = Buffer.from(_arg, "base64").toString();
    let profile: Profile | null = null
    try {
        let data = JSON.parse(base64ToString) as _DataQuery;
        token = data.bearer_token;
        if (token != null) {
            const api = new ApiSingWallet()
            profile = await (await api.getProfile(token)).result
        }

        if (profile) {
            return { profile, token }
        } else {
            return thunkApi.rejectWithValue(token)
        }
    } catch (e) {
        return thunkApi.rejectWithValue(e);
    }
}
);

export const login = createAsyncThunk('user/login', async (_arg, thunkApi) => {
    let idpHint = ''
    let authenticationOptions: any = {};
    if (idpHint) {
        authenticationOptions.idpHint = idpHint;
    }

    try {
        let account = await window['singConnect']['authenticate'](authenticationOptions)
        if (account) {
            const token = account.auth.token
            return token
        } else {
            return thunkApi.rejectWithValue(null);
        }

    } catch (e) {
        console.log('error login', e)
        return thunkApi.rejectWithValue(e);
    }
}
);


export const logout = createAsyncThunk('user/logout', async (_arg, thunkApi) => {
    try {
        await window['singConnect'].logout()
        return true
    } catch (e) {
        console.log('error login', e)
        return thunkApi.rejectWithValue(e);
    }
}
);


type UsersState = {
    user: Profile
    tokenBearer: string
    isLoading: boolean
    isLoggedIn: boolean
}

const initialState: UsersState = {
    user: {
        userId: "",
        nickname: "",
        email: "",
        firstName: "",
        lastName: "",
        username: "",
        hasMasterPin: true,
        avatar: "",
        googleId: "",
        facebookId: "",
        attributes: {
            locale: 'en',
        }
    },
    tokenBearer: '',
    isLoading: false,
    isLoggedIn: false,
}

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        clearState: (state) => {
            state.isLoading = false;
            state.isLoggedIn = false;
            return state;
        },

    },
    extraReducers: (builder) => {
        //check auth
        builder.addCase(checkAuthenticated.fulfilled, (state, { payload }) => {
            if (payload) {
                const { profile, token } = payload;
                state.user = profile;
                state.tokenBearer = token;
                state.isLoading = false;
                state.isLoggedIn = true;
            }

            console.log('state', state)
        })
        builder.addCase(checkAuthenticated.rejected, (state, _action) => {
            state.tokenBearer = '';
            state.isLoading = false;
            state.isLoggedIn = false;
        })
        builder.addCase(checkAuthenticated.pending, (state, _action) => {
            state.isLoading = true;
        })

        //login
        builder.addCase(login.fulfilled, (state, { payload }) => {
            state.tokenBearer = payload
            state.isLoading = false;
            state.isLoggedIn = true;
        })
        builder.addCase(login.rejected, (state, _action) => {
            state.isLoading = false;
            state.isLoggedIn = false;
        })
        builder.addCase(login.pending, (state, _action) => {
            state.isLoading = true;
        })

        //logout
        builder.addCase(logout.fulfilled, (state, { payload }) => {
            state.tokenBearer = '';
            state.isLoading = false;
            state.isLoggedIn = false;
        })
        builder.addCase(logout.rejected, (state, action) => {
            state.tokenBearer = '';
            state.isLoading = false;
            state.isLoggedIn = false;
        })
        builder.addCase(logout.pending, (state, action) => {
            state.isLoading = true;
        })
    },
});



export const { clearState } = userSlice.actions;
export const userSelector = (state: RootState) => state.user;
